import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en.json';
import ptTranslation from './locales/pt.json';

const browserLanguage = navigator.language || navigator.userLanguage; 
const normalizedLanguage = browserLanguage.toLowerCase();
const defaultLanguage = ['pt', 'pt-br', 'pt-pt'].includes(normalizedLanguage) ? 'pt' : 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    pt: {
      translation: ptTranslation,
    },
  },
  lng: defaultLanguage, 
  fallbackLng: 'en', 
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
